import { EventBus } from "../../../eventbus";

export default {
  props: {
    name: String,
    min: Number,
    max: Number,
    defaultValue: Number,
    gradient: String,
  },
  data() {
    return {
      value: "",
    };
  },
  created() {
    this.value = this.defaultValue;

    EventBus.$on(`vslider--reset`, (resetList) => {
      if (resetList.includes(this.name)) {
        this.value = this.defaultValue;
      }
    });
  },
  methods: {
    handleInput(e) {
      this.value = e.target.value;
    },
  },
};
